import React from 'react';
import { useHistory } from 'react-router-dom';
import { OptionPresetGroupType } from '@/services/option-preset/option-preset-group';
import { useOptionConfigurator } from '../OptionConfiguratorContext';
import { ImmersiveSignAndSend } from '../Room/components/ImmersiveSignAndSend';
import { buildConfiguratorUrl } from '../utils/buildConfiguratorUrl';

// Sign-and-send for the deadline overview (the standard options landing, buyer + seller). Signs the
// currently selected deadline — mirrors the disable + routing logic the tab bar used before it was
// removed, and reuses the shared sign-and-send flow (with its "apply standard selections" pre-check).
export const OverviewSignAndSend: React.FC = () => {
    const { selectedDeadlineId, configuratorData, projectData, baseUrl, viewOnly } = useOptionConfigurator();
    const history = useHistory();

    if (!selectedDeadlineId || !projectData) return null;

    const selectedDeadline = projectData.deadlines.find((d) => d.id === selectedDeadlineId);

    const hasUnpickedStyleGroups = !!configuratorData?.styleGroups.some((group) => {
        if (group.type === OptionPresetGroupType.Room && !group.roomId) return false;
        return group.forceSelection && !group.styles.some((s) => s.isPicked);
    });
    const isDeadlineExpired = selectedDeadline
        ? new Date(selectedDeadline.deadline) < new Date(new Date().toDateString())
        : false;
    const disableSignAndSend = hasUnpickedStyleGroups || isDeadlineExpired;

    const handleSignClick = () => {
        history.push(buildConfiguratorUrl({ baseUrl, deadlineId: selectedDeadlineId, segment: 'sign-pre' }));
    };

    return <ImmersiveSignAndSend disabled={disableSignAndSend} viewOnly={viewOnly} onProceed={handleSignClick} />;
};
